<template>
    <div :class="['rounded-lg shadow-lg overflow-hidden transition-all hover:shadow-xl', props.bgColor || 'bg-gradient-to-r from-blue-500 to-blue-600']">
        <div class="p-4">
            <div class="flex items-center justify-between">
                <div class="flex-1">
                    <p class="text-sm font-medium text-white/80 mb-1">{{ props.title }}</p>
                    <Loading v-if="props.loading" />
                    <div v-else class="text-3xl font-bold text-white">{{ formatValue(props.value) }}</div>
                </div>
                <div class="w-12 h-12 opacity-80 flex-shrink-0 text-white">
                    <component :is="props.icon" class="w-full h-full" />
                </div>
            </div>
            <div v-if="props.trend" class="mt-4 text-xs text-white/70">
                {{ props.trend }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import Loading from '@/components/TriadLoad.vue';

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    value: {
        type: [Number, String],
        default: 0
    },
    loading: {
        type: Boolean,
        default: false
    },
    icon: {
        type: [String, Object, Function],
        default: null
    },
    trend: {
        type: String,
        default: ''
    },
    bgColor: {
        type: String,
        default: 'bg-gradient-to-r from-blue-500 to-blue-600'
    }
});

const formatValue = (value) => {
    if (typeof value === 'number') {
        return value.toLocaleString();
    }
    return value;
};
</script>

